(ns common.resource.query.feed-importer
  (:require [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [common.queries :as queries]
            [common.queries.http :as qhttp]))

(defn- sort->query-param [{:keys [field sort]}]
  (if (and field sort)
    (str (when (= sort "desc")
           "-")
         (name field))
    ""))

(def active-fetch-interval 1000)

(def feed-importers-refetch
  (queries/make-refetch-interval-fn
   {:interval-fn (fn [^js query]
                   (let [some-in-progress? (some->> (.-data (.-state query)) .-pages ->clj (mapcat :items) (some (fn [{:keys [state]}] (when (= state "in progress") true))))]
                     (if some-in-progress?
                       active-fetch-interval
                       0)))}))

(defn feed-importers-query [{:keys [advertiser-id filters page-size sort]}]
  (let [sort-query-param (sort->query-param sort)]
    #js {:queryKey (->js ["feed-importers" advertiser-id filters page-size sort-query-param])
         :queryFn (fn [^js ctx]
                    (qhttp/post (qhttp/render :api/feed-importers-search
                                              {:advertiser-id advertiser-id}
                                              {:page (.-pageParam ctx)})
                                {:body (cond-> {}
                                         (seq filters) (assoc :filters filters)
                                         sort (assoc :sort (set/rename-keys sort {:sort :direction})))}))
         :initialPageParam 1
         :refetchInterval feed-importers-refetch
         :getNextPageParam (fn [_ pages]
                             (inc (count pages)))
         :enabled (boolean advertiser-id)}))

(defn latest-product-feed-import-errors-query [advertiser-id feed-id]
  #js {:queryKey #js ["latest-product-feed-import-errors-query" advertiser-id feed-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/feed-importers-latest-import
                                           {:advertiser-id advertiser-id
                                            :feed-importer-id feed-id})))
       :enabled (some? feed-id)})

(defn feed-importer-query [{:keys [advertiser-id feed-importer-id]}]
  #js {:queryKey #js ["feed-importer" advertiser-id feed-importer-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/feed-importer
                                           {:advertiser-id advertiser-id
                                            :feed-importer-id feed-importer-id})))
       :enabled (and (some? advertiser-id) (some? feed-importer-id))})

